import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, styled } from "@mui/material";
import { COLORS } from "../../constants";

const WideDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    maxWidth: "1000px",
    width: "80%",
  },
}));

export const AlertThreeOptionsDialog = ({
  open,
  title,
  cancelTitle,
  discardTitle,
  saveTitle,
  handleClose,
  handleDiscardAndContinue,
  handleSaveAndContinue,
  text,
}: {
  open: boolean;
  title: string;
  cancelTitle: string;
  discardTitle: string;
  saveTitle: string;
  handleClose: () => void;
  handleDiscardAndContinue: () => void;
  handleSaveAndContinue: () => void;
  text: string;
}) => {

  return (
    <React.Fragment>
      <WideDialog open={open} keepMounted onClose={handleClose} aria-describedby="alert-dialog-slide-description">
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{text}</DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button onClick={handleClose} sx={{color: COLORS.DIDACTO_DARK_RED}}>{cancelTitle}</Button>
          <Box>
            <Button onClick={handleDiscardAndContinue}>{discardTitle}</Button>
            <Button onClick={handleSaveAndContinue}>{saveTitle}</Button>
          </Box>
        </DialogActions>
      </WideDialog>
    </React.Fragment>
  );
};
